import "./style.scss";
import { NavLink } from "react-router-dom";
import Controls from "../Controls";
import { useWindowSize } from "../../../Helpers";
import Logo from "../img/ic-logo.svg?react";
import TabletLogo from "../img/ic-logo-small.svg?react";
import CloseButton from "@components/CloseButton";
import { useEffect, useState } from "react";

export default function TopBar({ openNav, setOpenNav, setExpanded, expanded }) {
  const { width } = useWindowSize();
  const MOBILE = width < 1020;
  const HD = width >= 1280;
  const XGA = width >= 1020;

  const [activeSkin, setActiveSkin] = useState(() => {
    const stored = localStorage.getItem("activeSkin");
    return stored || null;
  });

  const inputClass = {
    base: "navigation-top-bar",
    active: "active",
  };

  useEffect(() => {
    const updateSkin = () => {
      const stored = localStorage.getItem("activeSkin");
      setActiveSkin(stored || null);
    };

    window.addEventListener("skinChange", updateSkin);
    return () => {
      window.removeEventListener("skinChange", updateSkin);
    };
  }, []);

  return (
    <div
      className={`${inputClass.base} ${
        activeSkin ? `skin-${activeSkin}` : ""
      }`}
    >
      <>
        <NavLink
          onClick={() => {
            if (MOBILE) {
              setOpenNav(false);
            }
          }}
          to="/"
          className="logo"
        >
          <Logo />
        </NavLink>
        <NavLink to="/" className="logo-tablet">
          <TabletLogo />
        </NavLink>
      </>

      {XGA && !HD && expanded && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            setExpanded(false);
          }}
          className={`expanded-close ${
            activeSkin ? `skin-${activeSkin}` : ""
          }`}
        />
      )}

      {openNav ? (
        <CloseButton onClick={() => setOpenNav(false)} />
      ) : (
        <Controls setOpenNav={setOpenNav} />
      )}
    </div>
  );
}
